<template>
  <div id="Home_cover">
    <div class="inner" v-if="!this.$isOppo()">
      <div class="cover_container" >
        <template v-if="merchantCode==='grabpay'">
          <video playsinline preload loop muted autoplay>
            <source src="https://seagm-media.seagmcdn.com/mini_store/art-grabpay/cover.webm" type="video/webm">
            <source src="https://seagm-media.seagmcdn.com/mini_store/art-grabpay/cover.mp4" type="video/mp4">
          </video>
        </template>
        <template v-if="merchantCode===''">

        </template>
      </div>
      <div class="search"><router-link to="/search-products" class="btw"><span icon="search">{{$LangMessage(LangKey.Search)}}</span></router-link></div>
    </div>

<!--    oppo-->
    <div class="inner" v-if="this.$isOppo()">
      <div class="cover_container">
        <h1>{{storeTitle}}</h1>
        <h3>{{description}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCover",
  computed:{
    merchantCode(){
      return process.env.VUE_APP_MERCHANT_CODE
    },
    storeTitle() {
      return this.$store.getters.miniStore.storeTitle
    },
    description () {
      return this.$store.getters.miniStore.description
    }
  },
  props:{
    homeListLength:Number
  },
  methods:{
  }
}
</script>

<style scoped>

</style>
